// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","flagComment":"_2cH2sgFppXUPSicdg3SSbH","flagged":"_10BZfCbpMt1_VWXdv36mW-","reasonInput":"_3P-Hm3fREyiavFqSYVUFUf"};